module.exports = __webpack_public_path__ + "img/tally.529a55cd.png";